/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * マスタ列挙体
 */
export type MasterKey = 'consumptionTaxes' | 'roles' | 'offices' | 'tasks' | 'events' | 'applyUnits' | 'attendanceTypes' | 'expenseItems' | 'optionPrices' | 'extraFees' | 'noticeCategories';

export const MasterKey = {
    ConsumptionTaxes: 'consumptionTaxes' as MasterKey,
    Roles: 'roles' as MasterKey,
    Offices: 'offices' as MasterKey,
    Tasks: 'tasks' as MasterKey,
    Events: 'events' as MasterKey,
    ApplyUnits: 'applyUnits' as MasterKey,
    AttendanceTypes: 'attendanceTypes' as MasterKey,
    ExpenseItems: 'expenseItems' as MasterKey,
    OptionPrices: 'optionPrices' as MasterKey,
    ExtraFees: 'extraFees' as MasterKey,
    NoticeCategories: 'noticeCategories' as MasterKey
};

